/**
 * Länk till vägbeskrivning till ett ställe.
 *
 * Bara stället koordinater går till karttjänsten. Ingen startposition
 * skickas: kartappen vet var användaren är utan hjälp, och Beatspot ska
 * aldrig lämna ut den.
 */
export function directionsUrl(venue: {
  lat: number | null;
  lon: number | null;
}): string | null {
  if (!Number.isFinite(venue.lat) || !Number.isFinite(venue.lon)) return null;

  return `https://www.google.com/maps/dir/?api=1&destination=${venue.lat},${venue.lon}`;
}
